import { z } from 'zod';

import { OrgIdSchema } from '../_shared/identifiers';

import { CardIdSchema } from './card_id';

/**
 * Wire contract for the `card.meta.updated` fact kanban publishes (to the
 * shared card-events SNS topic) whenever a card's `subject`/`summary` is
 * updated, and consumes (from SQS) to re-run the async LLM triage classifier
 * for cards still without a squad.
 *
 * A fact, not a command: the `type` discriminator distinguishes it from
 * `card.created` on the same topic, and the consumer owns the decision to
 * triage. Payload is intentionally minimal — the consumer reloads the card,
 * the org triage config, and the squads from kanban's own store. `messageId`
 * is a publisher-controlled UUID used for log correlation. The SNS→SQS
 * subscription uses `RawMessageDelivery = true`, so the SQS body is this JSON
 * directly (no SNS envelope to strip).
 */
export const CardMetaUpdatedEventSchema = z
  .object({
    type: z.literal('card.meta.updated'),
    messageId: z.uuid(),
    orgId: OrgIdSchema,
    cardId: CardIdSchema,
    occurredAt: z.iso.datetime(),
  })
  .strict();

export type CardMetaUpdatedEvent = z.infer<typeof CardMetaUpdatedEventSchema>;
